import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ActionsBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import {
  defaultButtonState,
  hoverButtonState,
} from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/buttonStates";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import { sizing } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/sizing";
import {
  ContentProp,
  DesignProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { defaultPrimaryStyles } from "./defaultPrimaryStyles";

export const meta: ComponentMeta = {
  name: "Button",
  version: 1,
  nameI18n: "builder_ui.block_type.button",
  category: [ActionsBlock],
  isHidden: true,
  props: {
    text: {
      name: "Text",
      nameI18n: "builder_ui.prop_type.text",
      category: [ContentProp],
      prop: "other",
      type: "rich-text",
    },
    href: {
      name: "Link",
      nameI18n: "builder_ui.prop_type.link",
      category: [ContentProp],
      prop: "other",
      type: "string",
    },
    target: {
      name: "Target",
      nameI18n: "builder_ui.prop_type.target",
      category: [ContentProp],
      prop: "other",
      type: "select",
      defaultValue: "_self",
      options: [
        {
          label: "Self",
          labelI18n: "builder_ui.prop_type.target_types.self",
          value: "_self",
        },
        {
          label: "Blank",
          labelI18n: "builder_ui.prop_type.target_types.blank",
          value: "_blank",
        },
      ],
    },
    buttonType: {
      name: "Button Type",
      nameI18n: "builder_ui.prop_type.button_type",
      category: [DesignProp],
      prop: "other",
      type: "select",
      defaultValue: "primary",
      options: [
        {
          label: "Primary",
          labelI18n: "builder_ui.prop_type.button_type.primary",
          value: "primary",
        },
        {
          label: "Secondary",
          labelI18n: "builder_ui.prop_type.button_type.secondary",
          value: "secondary",
        },
        {
          label: "Custom",
          labelI18n: "builder_ui.prop_type.button_type.custom",
          value: "custom",
        },
      ],
    },
    styles: {
      name: "Styles",
      nameI18n: "builder_ui.prop_type.styles",
      category: [DesignProp],
      prop: "custom",
      type: "button",
      attributes: {
        default: {
          ...defaultButtonState,
          defaultValue: {
            backgroundColor: {
              ...defaultButtonState.defaultValue.backgroundColor,
              defaultValue: defaultPrimaryStyles.default.backgroundColor,
            },
            borderColor: {
              ...defaultButtonState.defaultValue.borderColor,
              defaultValue: defaultPrimaryStyles.default.borderColor,
            },
            borderRadius: {
              ...defaultButtonState.defaultValue.borderRadius,
              defaultValue: defaultPrimaryStyles.default.borderRadius,
            },
            borderWidth: {
              ...defaultButtonState.defaultValue.borderWidth,
              defaultValue: defaultPrimaryStyles.default.borderWidth,
            },
            color: {
              ...defaultButtonState.defaultValue.color,
              defaultValue: defaultPrimaryStyles.default.color,
            },
            fontSize: {
              ...defaultButtonState.defaultValue.fontSize,
              defaultValue: defaultPrimaryStyles.default.fontSize,
            },
            fontStyle: {
              ...defaultButtonState.defaultValue.fontStyle,
              defaultValue: defaultPrimaryStyles.default.fontStyle,
            },
            fontWeight: {
              ...defaultButtonState.defaultValue.fontWeight,
              defaultValue: defaultPrimaryStyles.default.fontWeight,
            },
            lineHeight: {
              ...defaultButtonState.defaultValue.lineHeight,
              defaultValue: defaultPrimaryStyles.default.lineHeight,
            },
            textAlign: {
              ...defaultButtonState.defaultValue.textAlign,
              defaultValue: defaultPrimaryStyles.default.textAlign,
            },
            textDecoration: {
              ...defaultButtonState.defaultValue.textDecoration,
              defaultValue: defaultPrimaryStyles.default.textDecoration,
            },
            textTransform: {
              ...defaultButtonState.defaultValue.textTransform,
              defaultValue: defaultPrimaryStyles.default.textTransform,
            },
          },
        },
        hover: {
          ...hoverButtonState,
          defaultValue: {
            backgroundColor: {
              ...hoverButtonState.defaultValue.backgroundColor,
              defaultValue: defaultPrimaryStyles.hover.backgroundColor,
            },
            borderColor: {
              ...hoverButtonState.defaultValue.borderColor,
              defaultValue: defaultPrimaryStyles.hover.borderColor,
            },
            borderRadius: {
              ...hoverButtonState.defaultValue.borderRadius,
              defaultValue: defaultPrimaryStyles.hover.borderRadius,
            },
            borderWidth: {
              ...hoverButtonState.defaultValue.borderWidth,
              defaultValue: defaultPrimaryStyles.hover.borderWidth,
            },
            color: {
              ...hoverButtonState.defaultValue.color,
              defaultValue: defaultPrimaryStyles.hover.color,
            },
            fontSize: {
              ...hoverButtonState.defaultValue.fontSize,
              defaultValue: defaultPrimaryStyles.hover.fontSize,
            },
            fontStyle: {
              ...hoverButtonState.defaultValue.fontStyle,
              defaultValue: defaultPrimaryStyles.hover.fontStyle,
            },
            fontWeight: {
              ...hoverButtonState.defaultValue.fontWeight,
              defaultValue: defaultPrimaryStyles.hover.fontWeight,
            },
            lineHeight: {
              ...hoverButtonState.defaultValue.lineHeight,
              defaultValue: defaultPrimaryStyles.hover.lineHeight,
            },
            textAlign: {
              ...hoverButtonState.defaultValue.textAlign,
              defaultValue: defaultPrimaryStyles.hover.textAlign,
            },
            textDecoration: {
              ...hoverButtonState.defaultValue.textDecoration,
              defaultValue: defaultPrimaryStyles.hover.textDecoration,
            },
            textTransform: {
              ...hoverButtonState.defaultValue.textTransform,
              defaultValue: defaultPrimaryStyles.hover.textTransform,
            },
          },
        },
        sizing: {
          ...sizing,
          defaultValue: defaultPrimaryStyles.sizing,
        },
        margin: {
          ...margin,
          defaultValue: defaultPrimaryStyles.margin,
        },
        padding: {
          ...padding,
          defaultValue: defaultPrimaryStyles.padding,
        },
      },
    },
  },
};
